var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "jobtype" }, [
    _c("div", { staticClass: "group" }, [
      _c("input", {
        staticClass: "radio",
        attrs: {
          type: "radio",
          id: "Open",
          name: "status",
          value: "Open",
          disabled: !_vm.perms.includes("130")
        },
        domProps: { checked: _vm.status == "Open" },
        on: {
          click: function($event) {
            return _vm.radioSelect("Open")
          }
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "Open" } }, [_vm._v("Open")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "group" }, [
      _c("input", {
        staticClass: "radio",
        attrs: {
          type: "radio",
          id: "Completed",
          name: "status",
          value: "Completed",
          disabled: !_vm.perms.includes("130")
        },
        domProps: { checked: _vm.status == "Completed" },
        on: {
          click: function($event) {
            return _vm.radioSelect("Completed")
          }
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "Completed" } }, [_vm._v("Completed")])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "group" }, [
      _c("input", {
        staticClass: "radio",
        attrs: {
          type: "radio",
          id: "Cancelled",
          name: "status",
          value: "Cancelled",
          disabled: !_vm.perms.includes("130")
        },
        domProps: { checked: _vm.status == "Cancelled" },
        on: {
          click: function($event) {
            return _vm.radioSelect("Cancelled")
          }
        }
      }),
      _vm._v(" "),
      _c("label", { attrs: { for: "Cancelled" } }, [_vm._v("Cancelled")])
    ]),
    _vm._v(" "),
    _vm.select == "Cancelled"
      ? _c(
          "div",
          { staticStyle: { display: "flex", "margin-bottom": "5px" } },
          [
            _c(
              "p",
              {
                staticStyle: {
                  width: "fit-content",
                  margin: "0px",
                  "margin-right": "10px"
                }
              },
              [_vm._v("Cancellation Reason: ")]
            ),
            _vm._v(" "),
            _c("autocomplete", {
              staticStyle: { "flex-grow": "1" },
              attrs: { type: 64 },
              model: {
                value: _vm.cancelReason,
                callback: function($$v) {
                  _vm.cancelReason = $$v
                },
                expression: "cancelReason"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.select == "Cancelled" ||
    (_vm.select == "Open" && _vm.originalStatus == "Completed")
      ? _c("div", { staticStyle: { display: "flex" } }, [
          _c(
            "p",
            {
              staticStyle: {
                width: "fit-content",
                margin: "0px",
                "margin-right": "10px"
              }
            },
            [_vm._v("Change Comment: ")]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.statusComment,
                expression: "statusComment"
              }
            ],
            staticStyle: { "flex-grow": "1" },
            domProps: { value: _vm.statusComment },
            on: {
              change: function($event) {
                return _vm.sendData()
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.statusComment = $event.target.value
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a3631b5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a3631b5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/status.vue
// module id = 862
// module chunks = 0